import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import SurveyStatsSidebar from 'apps/hiring/components/survey-stats-sidebar';
import PropTypes from 'prop-types';
import Loading from 'components/loading';
import EmployeeList from 'apps/hiring/components/survey-list';
import SurveyStatusSidebar from 'apps/hiring/components/survey-status-sidebar';
import CollapsableSidebar from 'apps/hiring/components/collapsable-sidebar';

class EmployeeSurvey extends React.Component {
  state = {
    selected: null
  }

  handleUserClick = (user) => {
    this.setState({
      selected: user
    });
  }

  handleSidebarClose = () => {
    this.setState({
      selected: null
    });
  }

  render() {
    const {
      graph_loading,
      stats,
      users,
      pagination
    } = this.props;

    const {
      selected
    } = this.state;

    if (graph_loading) {
      return <Loading />;
    }

    return (
      <Fragment>
        <div className="hiring-body">
          <section className="hiring-section">
            <SurveyStatsSidebar stats={stats} employee/>
            <CollapsableSidebar open={selected} onClose={this.handleSidebarClose}>
              <SurveyStatusSidebar user={selected} />
            </CollapsableSidebar>
            {
              graph_loading
                ? <h1>Loading</h1>
                : (
                  <div className="hiring-survey-list">
                    <EmployeeList
                      users={users}
                      type="employee"
                      linkBase={`/hiring/employees`}
                      loading={graph_loading}
                      pagination={pagination}
                      onClick={(user) => this.setState({ selected: user })}
                    />
                  </div>
                )
            }
          </section>
        </div>
      </Fragment>
    );
  }
}

EmployeeSurvey.propTypes ={
  graph_loading: PropTypes.bool,
  stats: PropTypes.array,
  users: PropTypes.array,
  pagination: PropTypes.number
};

export default EmployeeSurvey;
